import React, { useEffect, useState } from "react";
import { IDisplayPeriod } from "../../../types";
import { TimeSection } from "../time-section/time-section";
import { NoTimeSection } from "../no-time-section/no-time-section";
import styled from "styled-components";
import { selectionStore } from "../../../stores/selection.store";
import { selectionStoreChangesService } from "../../../services/selection-store-changes.service";
import { GolEventListener } from "../../calendar/calendar";

interface IStyled {
  disabled?: boolean;
}

const TimeSectionWrapper = styled.div<IStyled>`
  width: 300px;
  background-color: ${(props) => props.theme.backgroundColor};
  padding: 4px 6px 12px;
  margin-top: 2px;
  box-shadow: 0 2px 6px rgb(0 0 0 / 5%), 0 0 0 1px rgb(0 0 0 / 7%);
  border-radius: 4px;
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
`;

type PeriodsProps = {
  displayPeriods: Array<IDisplayPeriod>;
};

export const PeriodsView = (props: PeriodsProps) => {
  const [selectedGuests, setSelectedGuests] = useState(selectionStore.guests);

  useEffect(() => {
    selectionStoreChangesService.registerListener(
      "guests",
      [GolEventListener.Guests],
      () => {
        setSelectedGuests(selectionStore.guests);
      }
    );

    return () => {
      selectionStoreChangesService.unregisterListener("guests");
    };
  }, []);

  const renderPeriods = () => {
    return props.displayPeriods.map((displayPeriod: IDisplayPeriod) => {
      if (displayPeriod.hours) {
        return (
          <TimeSection
            key={displayPeriod.titleKey}
            sectionTitleKey={displayPeriod.titleKey}
            sectionTimeSlots={displayPeriod.hours}
          />
        );
      } else {
        return (
          <NoTimeSection
            key={displayPeriod.titleKey}
            sectionTitleKey={displayPeriod.titleKey}
            noHourReason={displayPeriod.noHourReason!}
            nonBookableEvent={displayPeriod.nonBookableEvent}
          />
        );
      }
    });
  };
  return (
    <TimeSectionWrapper
      data-test="periods-view"
      disabled={selectedGuests === 0}
    >
      {renderPeriods()}
    </TimeSectionWrapper>
  );
};
